<template>
  <div class="vendor-contact-name">
    <router-link
      v-if="allowAccessContact"
      :to="toRoute"
    >
      {{ displayName }}
    </router-link>
    <span v-else>{{ displayName }}</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { displayI18nFullName } from '@/utils/fullName'
import { findViewContactRouteByUserType } from '@/utils/ccdUtil'
import { aclHelper, ccdPermsTypes } from '@/utils/aclHelper'

export default {
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('user', ['isContractor']),
    rawRecord () {
      return this.record.raw
    },
    ccdContact () {
      return this.record.raw.ccdContact
    },
    displayName () {
      const ccdContact = this.ccdContact
      return displayI18nFullName(ccdContact.firstName, ccdContact.lastName) || ccdContact.name
    },
    toRoute () {
      const routeName = findViewContactRouteByUserType()
      return { name: routeName, params: { id: this.ccdContact.id } }
    },
    allowAccessContact () {
      return aclHelper.getAccess(ccdPermsTypes.contact.read) || this.isContractor
    },
  },
}
</script>

<style lang="scss" scoped>
.vendor-contact-name {
  a {
    color: #0C3A58;
    text-decoration: underline;
  }
}
</style>
